var fn = function( obj ){
var __t,__p='';
__p+='\nc = texture2D(tInput,texCoordVP).xyz;';
return __p;
};
fn.toString=fn;
module.exports = fn;